import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import fotaViewTypeEnum, {
  ModuleToOpen,
} from "../../constants/fota-view-type-enum";
import systemModuleEnum from "../../constants/system-module-enum";
import { useStore } from "../../contexts/StoreProvider";
import { isOperationPermitted } from "../../helpers/action-permission-helper";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import { formatMessage } from "../../translations/format-message";

import "./fota-tnt-release.css";
import IPageInfo from "../../models/ICommon";
import FotaHostViewFilterForm from "./components/fota-host-view-filter-form";
import _ from "lodash";
import { getUserTypeFromLocalStorage } from "../../helpers/local-stotrage-helper";
import userTypeEnum from "../../constants/user-type-enum";
import FotaHostView from "./fota-host-view";
import FotaJetView from "./fota-jet-view";
import FotaModemView from "./fota-modem-view";

const FotaTenantRelease = (props: any) => {
  const { fotaTntReleaseStore } = useStore();
  const {
    error,
    inProgress,
    reset,
    setSelectedView,
    isSelectedView,
    setIsAddUpdatePopupOpen,
    resetFotaHostConfigState,
    filterDetails,
    setFilterDetail,
    setIsFilterPopupOpen,
    isFilterPopupOpen
  } = fotaTntReleaseStore;

  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [openPanel, setOpenPanel] = useState(false);
  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const fotaViewToggleHandler = (viewType: fotaViewTypeEnum) => {
    setSelectedView({ ...isSelectedView, view: viewType, isViewChanged: true });
  };

  const fotaModuleToOpenToggleHandler = (moduleToOpen: ModuleToOpen) => {
    setSelectedView({
      ...isSelectedView,
      moduleToOpen: moduleToOpen,
      isViewChanged: true,
    });
    // setisViewChanged(true);
  };

  const openFilterPopUpHandler = () => {
    closePanelHandler();
    setIsFilterPopupOpen(true);
  };

  const closeFilterPopupHandler = () => {
    setIsFilterPopupOpen(false);
  };

  const filterSubmitHandler = (values: any) => {
    closeFilterPopupHandler();
    setPageInfo({ ...pageInfo, currentPage: 1, isRefreshPage: true });
    setFilterDetail({ ...values, isFilterActive: true });
    closePanelHandler();
  };

  const resetFilter = () => {
    closePanelHandler();
    setFilterDetail({
      SearchBy: -1,
      ScheduleStartDate: "",
      ScheduleEndDate: "",
      ConfigName: "",
      VersionNo: "",
      isFilterActive: false,
    });
    setPageInfo({ ...pageInfo, currentPage: 1, isRefreshPage: true });
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      toast.error(formatMessage(error));
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    return (() => {
      setSelectedView({ view: (getUserTypeFromLocalStorage() == userTypeEnum.SystemUser ? fotaViewTypeEnum.Modem : fotaViewTypeEnum.Host), moduleToOpen: ModuleToOpen.Schedule, isViewChanged: false })
    })
  }, []);

  const closePanelHandler = () => {
    resetFotaHostConfigState();
    setOpenPanel(false);
    setSelectedRow({});
    setSelectedId(-1);
  };

  const openAddPopupHandler = () => {
    closePanelHandler();
    setSelectedId(-1);
    setIsAddUpdatePopupOpen(true);
  };

  return (
    <>
      {isFilterPopupOpen && (
        <FotaHostViewFilterForm
          initialValues={_.omit(filterDetails, ["isFilterActive"])}
          isFilterActive={filterDetails.isFilterActive}
          submitHandler={filterSubmitHandler}
          modalClosed={closeFilterPopupHandler}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="row g-0  align-items-center">
              <div className="col-sm-6 col-12">
                <div className="filter-left-area">
                  <ul className="d-flex align-items-center">
                    <li className="fotaTabs-switch">
                      <button
                        className={`host ${isSelectedView.view === fotaViewTypeEnum.Host
                          ? "active"
                          : ""
                          }`}
                        type="button"
                        onClick={
                          isSelectedView.view !== fotaViewTypeEnum.Host
                            ? () => {
                              closePanelHandler();
                              fotaViewToggleHandler(fotaViewTypeEnum.Host);
                            }
                            : () => { }
                        }
                      >
                        <svg
                          clipRule="evenodd"
                          fill="currentColor"
                          className="me-1"
                          fillRule="evenodd"
                          height="18"
                          strokeLinejoin="round"
                          strokeMiterlimit="2"
                          viewBox="0 0 24 24"
                          width="18"
                          xmlns="http://www.w3.org/2000/svg"
                          id="fi_8028666"
                        >
                          <g id="Icon">
                            <path d="m22.75 3c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                            <path d="m22.75 10.5c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                            <path d="m22.75 18c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                          </g>
                        </svg>
                        <FormattedMessage id="host" />
                      </button>
                      <button
                        className={`modem ${isSelectedView.view === fotaViewTypeEnum.Modem
                          ? "active"
                          : ""
                          }`}
                        type="button"
                        onClick={
                          isSelectedView.view !== fotaViewTypeEnum.Modem
                            ? () => {
                              closePanelHandler();
                              fotaViewToggleHandler(fotaViewTypeEnum.Modem);
                            }
                            : () => { }
                        }
                      >
                        <svg
                          id="Layer_1"
                          fill="currentColor"
                          enableBackground="new 0 0 512 512"
                          height="18px"
                          viewBox="0 0 512 512"
                          width="18px"
                          className="me-1"
                        >
                          <g id="XMLID_493_">
                            <path
                              id="XMLID_582_"
                              d="M66.707,93.022c-2.006-8.037-10.146-12.921-18.187-10.92c-8.038,2.007-12.926,10.149-10.919,18.188   l35.857,143.613h30.921L66.707,93.022z"
                            />
                            <path
                              id="XMLID_584_"
                              d="M454.5,244.043l35.892-143.754c2.007-8.038-2.882-16.181-10.919-18.188   c-8.04-2.004-16.18,2.882-18.187,10.92l-37.672,150.881H449.5C451.178,243.903,452.845,243.952,454.5,244.043z"
                            />
                            <path
                              id="XMLID_598_"
                              d="M449.5,273.903h-389c-33.36,0-60.5,27.141-60.5,60.5v64.444c0,16.267,13.234,29.5,29.5,29.5h451   c16.266,0,29.5-13.233,29.5-29.5v-64.444C510,301.044,482.86,273.903,449.5,273.903z M87.223,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S95.507,367.676,87.223,367.676z M131.667,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S139.951,367.676,131.667,367.676z M176.112,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S184.396,367.676,176.112,367.676z M414.928,367.676h-64.373   c-8.284,0-15-6.716-15-15s6.716-15,15-15h64.373c8.284,0,15,6.716,15,15S423.212,367.676,414.928,367.676z"
                            />
                          </g>
                        </svg>
                        <FormattedMessage id="modem" />
                      </button>
                      <button
                        className={`jet ${isSelectedView.view === fotaViewTypeEnum.Jet
                          ? "active"
                          : ""
                          }`}
                        type="button"
                        onClick={
                          isSelectedView.view !== fotaViewTypeEnum.Jet
                            ? () => {
                              closePanelHandler();
                              fotaViewToggleHandler(fotaViewTypeEnum.Jet);
                            }
                            : () => { }
                        }
                      >
                        <svg
                          className="me-1"
                          fill="currentColor"
                          height="18px"
                          width="18px"
                          viewBox="0 0 512 512"
                          role="img"
                        >
                          <g>
                            <circle cx="391.5" cy="288.655" r="18.734" />
                            <path d="m512 202.407h-209.638c-6.342 19.553-24.723 33.734-46.362 33.734-26.872 0-48.734-21.862-48.734-48.734 0-21.639 14.181-40.02 33.734-46.362v-141.045h-105.5v176.983c19.553 6.342 33.734 24.723 33.734 46.362 0 26.872-21.862 48.734-48.734 48.734s-48.734-21.862-48.734-48.734c0-21.639 14.181-40.02 33.734-46.362v-176.983h-105.5v309.593h209.638c6.342-19.553 24.723-33.734 46.362-33.734 26.872 0 48.734 21.862 48.734 48.734 0 21.639-14.181 40.02-33.734 46.362v141.045h105.5v-176.983c-19.553-6.342-33.734-24.723-33.734-46.362 0-26.872 21.862-48.734 48.734-48.734s48.734 21.862 48.734 48.734c0 21.639-14.181 40.02-33.734 46.362v176.983h105.5z" />
                            <path d="m338.514 86.203c0 10.331 8.404 18.735 18.734 18.735s18.734-8.404 18.734-18.735c0-10.33-8.404-18.734-18.734-18.734s-18.734 8.404-18.734 18.734z" />
                            <path d="m271 141.045c14.825 4.808 26.554 16.537 31.362 31.362h209.638v-71.204h-108.39c-6.342 19.554-24.723 33.735-46.362 33.735-26.872 0-48.734-21.862-48.734-48.735 0-26.872 21.862-48.734 48.734-48.734 21.639 0 40.02 14.181 46.362 33.734h108.39v-71.203h-241z" />
                            <path d="m241 370.955c-14.825-4.808-26.554-16.537-31.362-31.362h-209.638v71.204h108.389c6.342-19.554 24.723-33.735 46.363-33.735 26.872 0 48.734 21.862 48.734 48.735 0 26.872-21.862 48.734-48.734 48.734-21.64 0-40.021-14.181-46.363-33.734h-108.389v71.203h241z" />
                            <circle cx="120.5" cy="223.345" r="18.734" />
                            <circle cx="256" cy="187.407" r="18.734" />
                            <path d="m173.486 425.797c0-10.331-8.404-18.735-18.734-18.735-10.331 0-18.735 8.404-18.735 18.735 0 10.33 8.404 18.734 18.735 18.734 10.33 0 18.734-8.404 18.734-18.734z" />
                            <circle cx="256" cy="324.593" r="18.734" />
                          </g>
                        </svg>
                        <FormattedMessage id="jet" />
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="add-list">
                  <ul className="d-flex align-items-center">
                    {
                      (
                        isSelectedView.moduleToOpen === ModuleToOpen.Schedule) &&
                      <>
                        {filterDetails.isFilterActive == true ? (
                          <li>
                            <button
                              data-testid="FilterButton"
                              className="btn btn-light mx-2"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={resetFilter}
                              title={formatMessage("reset_filter")}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                version="1.1"
                                id="Layer_1"
                                x="0px"
                                y="0px"
                                width="20px"
                                height="20px"
                                viewBox="0 0 122.88 110.668"
                                enableBackground="new 0 0 122.88 110.668"
                              >
                                <g>
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M91.124,15.645c12.928,0,23.406,10.479,23.406,23.406 c0,12.927-10.479,23.406-23.406,23.406c-12.927,0-23.406-10.479-23.406-23.406C67.718,26.125,78.197,15.645,91.124,15.645 L91.124,15.645z M2.756,0h117.322c1.548,0,2.802,1.254,2.802,2.802c0,0.848-0.368,1.622-0.996,2.139l-10.667,13.556 c-1.405-1.375-2.95-2.607-4.614-3.672l6.628-9.22H9.43l37.975,46.171c0.59,0.516,0.958,1.254,0.958,2.102v49.148l21.056-9.623 V57.896c1.651,1.9,3.548,3.582,5.642,4.996v32.133c0,1.105-0.627,2.064-1.586,2.506l-26.476,12.758 c-1.327,0.773-3.023,0.332-3.798-1.033c-0.258-0.441-0.368-0.92-0.368-1.4V55.02L0.803,4.756c-1.07-1.106-1.07-2.839,0-3.945 C1.355,0.258,2.056,0,2.756,0L2.756,0z M96.93,28.282c1.328-1.349,3.489-1.355,4.825-0.013c1.335,1.342,1.341,3.524,0.013,4.872 l-5.829,5.914l5.836,5.919c1.317,1.338,1.299,3.506-0.04,4.843c-1.34,1.336-3.493,1.333-4.81-0.006l-5.797-5.878l-5.807,5.889 c-1.329,1.349-3.489,1.355-4.826,0.013c-1.335-1.342-1.341-3.523-0.013-4.872l5.83-5.913l-5.836-5.919 c-1.317-1.338-1.3-3.507,0.04-4.843c1.339-1.336,3.492-1.333,4.81,0.006l5.796,5.878L96.93,28.282L96.93,28.282z"
                                  />
                                </g>
                              </svg>
                            </button>
                          </li>
                        ) : (
                          ""
                        )}
                        <li data-testid="Filter">
                          <div className="dropdown">
                            <button
                              data-testid="FilterButton"
                              className="btn btn-light mx-2"
                              type="button"
                              onClick={openFilterPopUpHandler}
                              title={formatMessage("filter")}
                            >
                              <svg
                                className="svg-icon"
                                width="20px"
                                height="20px"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M859.02 234.524l0.808-0.756 0.749-0.813c27.047-29.356 33.876-70.34 17.823-106.957-15.942-36.366-50.416-58.957-89.968-58.957H163.604c-38.83 0-73.043 22.012-89.29 57.444-16.361 35.683-10.632 76.301 14.949 106.004l0.97 1.126 280.311 266.85 2.032 312.074c0.107 16.502 13.517 29.805 29.995 29.805l0.2-0.001c16.568-0.107 29.912-13.626 29.804-30.194l-2.198-337.564-296.478-282.241c-9.526-11.758-11.426-26.933-5.044-40.851 6.446-14.059 19.437-22.452 34.75-22.452h624.828c15.6 0 28.69 8.616 35.017 23.047 6.31 14.391 3.924 29.831-6.354 41.497l-304.13 284.832 1.302 458.63c0.047 16.54 13.469 29.916 29.998 29.915h0.087c16.568-0.047 29.962-13.517 29.915-30.085L573.04 502.36l285.98-267.836z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M657.265 595.287c0 16.498 13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.498 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997H687.262c-16.498 0-29.997 13.499-29.997 29.997z m273.894 138.882H687.262c-16.498 0-29.997 13.499-29.997 29.997s13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.499 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997z m0 168.878H687.262c-16.498 0-29.997 13.499-29.997 29.997s13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.499 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997z"
                                  fill="currentColor"
                                />
                              </svg>
                            </button>
                          </div>
                        </li>
                      </>
                    }
                    <li className="fotaTabs-switch p-0">
                      <button
                        className={`config ${isSelectedView.moduleToOpen === ModuleToOpen.Config
                          ? "active"
                          : ""
                          }`}
                        type="button"
                        onClick={
                          isSelectedView.moduleToOpen !== ModuleToOpen.Config
                            ? () => {
                              closePanelHandler();
                              fotaModuleToOpenToggleHandler(
                                ModuleToOpen.Config
                              );
                            }
                            : () => { }
                        }
                      >
                        <svg
                          clipRule="evenodd"
                          fill="currentColor"
                          className="me-1"
                          fillRule="evenodd"
                          height="18"
                          strokeLinejoin="round"
                          strokeMiterlimit="2"
                          viewBox="0 0 24 24"
                          width="18"
                          xmlns="http://www.w3.org/2000/svg"
                          id="fi_8028666"
                        >
                          <g id="Icon">
                            <path d="m22.75 3c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                            <path d="m22.75 10.5c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                            <path d="m22.75 18c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                          </g>
                        </svg>
                        <FormattedMessage id="config" />
                      </button>
                      <button
                        className={`schedule ${isSelectedView.moduleToOpen === ModuleToOpen.Schedule
                          ? "active"
                          : ""
                          }`}
                        type="button"
                        onClick={
                          isSelectedView.moduleToOpen !== ModuleToOpen.Schedule
                            ? () => {
                              closePanelHandler();
                              fotaModuleToOpenToggleHandler(
                                ModuleToOpen.Schedule
                              );
                            }
                            : () => { }
                        }
                      >
                        <svg
                          clipRule="evenodd"
                          fill="currentColor"
                          className="me-1"
                          fillRule="evenodd"
                          height="18"
                          strokeLinejoin="round"
                          strokeMiterlimit="2"
                          viewBox="0 0 24 24"
                          width="18"
                          xmlns="http://www.w3.org/2000/svg"
                          id="fi_8028666"
                        >
                          <g id="Icon">
                            <path d="m22.75 3c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                            <path d="m22.75 10.5c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                            <path d="m22.75 18c0-.464-.184-.909-.513-1.237-.328-.329-.773-.513-1.237-.513-3.414 0-14.586 0-18 0-.464 0-.909.184-1.237.513-.329.328-.513.773-.513 1.237v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-17.25.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm10.5.25h-3c-.414 0-.75.336-.75.75s.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"></path>
                          </g>
                        </svg>
                        <FormattedMessage id="schedule" />
                      </button>
                    </li>
                    {isOperationPermitted(systemModuleEnum.Fota, "Add") && (
                      (
                        isSelectedView.view === fotaViewTypeEnum.Host ||
                        (isSelectedView.view === fotaViewTypeEnum.Modem &&
                          isSelectedView.moduleToOpen === ModuleToOpen.Schedule) ||
                        (isSelectedView.view === fotaViewTypeEnum.Jet &&
                          isSelectedView.moduleToOpen === ModuleToOpen.Schedule)
                      ) && (
                        <li title={formatMessage("add")}>
                          <LoaderButton
                            id="fotaUpdateModal"
                            text="add"
                            onClick={() => openAddPopupHandler()}
                          />
                        </li>
                      )
                    )}

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isSelectedView.view === fotaViewTypeEnum.Host && (
        <FotaHostView
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          openPanel={openPanel}
          setOpenPanel={setOpenPanel}
          closePanelHandler={closePanelHandler}
          pageInfo={pageInfo}
          setPageInfo={setPageInfo}
        />
      )}
      {isSelectedView.view === fotaViewTypeEnum.Jet && (
        <FotaJetView
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          openPanel={openPanel}
          setOpenPanel={setOpenPanel}
          closePanelHandler={closePanelHandler}
          pageInfo={pageInfo}
          setPageInfo={setPageInfo}
        />
      )}
      {isSelectedView.view === fotaViewTypeEnum.Modem && (
        <FotaModemView
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          openPanel={openPanel}
          setOpenPanel={setOpenPanel}
          closePanelHandler={closePanelHandler}
          pageInfo={pageInfo}
          setPageInfo={setPageInfo}
        />
      )}
    </>
  );
};

export default observer(FotaTenantRelease);
